import { environment } from '../../../environments/environment';

/** Entra ID (Azure AD) block on `environment` — optional until MSAL is enabled. */
export type AzureAdEnvironment = {
  enabled: boolean;
  clientId: string;
  tenantId: string;
  /** Must match SPA redirect URI in App Registration exactly (HTTPS in production). */
  redirectUri: string;
  /** Scopes for interactive sign-in (e.g. Microsoft Graph `User.Read`). */
  loginScopes: string[];
  /** Scopes for your backend API (e.g. `api://<api-app-id>/access_as_user`). */
  apiScopes: string[];
};

export function getAzureAdConfig(): AzureAdEnvironment | null {
  const ad = (environment as { azureAd?: Partial<AzureAdEnvironment> }).azureAd;
  if (!ad?.enabled) {
    return null;
  }
  return {
    enabled: true,
    clientId: ad.clientId ?? '',
    tenantId: ad.tenantId ?? '',
    redirectUri: ad.redirectUri ?? '',
    loginScopes: ad.loginScopes?.length ? ad.loginScopes : ['User.Read'],
    apiScopes: ad.apiScopes?.length ? ad.apiScopes : []
  };
}

export function isAzureAdEnabled(): boolean {
  return getAzureAdConfig() != null;
}
